'use strict';

// import $ from 'jquery';
// import modal from 'jquery-modal';
// import { Carusel } from '../carusel/carusel';

export default class ModalGallery {
	constructor(params) {

	}

	init() {

	}
}
